import React from 'react'

const AuthorisedBadge = ({authorised}) => (
  authorised ?
    <div className="authorised-person__badge">
        Authorised
    </div> :
    null
)

export default AuthorisedBadge


// WEBPACK FOOTER //
// ./src/auth-personnel/views/badge.jsx